(function(angular){
	'use strict';

	angular
		.module('navModule')
		.directive('nav', [
			'$document', 
			'$cookies',
			'$location',
			'$window',
			navFunction
		]);
			
	function navFunction(
		$document,
		$cookies,
		$location,
		$window) {
		
		return {
			restrict: 'A',
			link: function($scope, $elem, $attrs){					

				var freezeVp = function(e) {
					e.preventDefault();
				};

				$scope.open = false;
				
				$scope.isActive = function(urlSlug){
					return $location.path().indexOf(urlSlug) !== -1;
				};

				$scope.toggle = function() {
					
					var scrollPosition = $window.scrollY;
				
					if($scope.open) {
						$document[0].getElementsByClassName('mobile-nav__flyout-dimmer')[0].removeEventListener('touchmove', freezeVp, false);
						$document[0].body.className = $document[0].body.className.replace('body--state-mobile-nav-active', '');
						$scope.open = false;
					} else {
						$document[0].getElementsByClassName('mobile-nav__flyout-dimmer')[0].addEventListener('touchmove', freezeVp, false);
						$document[0].body.className = 'body--state-mobile-nav-active';
						$scope.open = true;
					}
				};

				angular.element($window).on('scroll', function() {
					
					var scrolled = $window.pageYOffset > 500 ? true : false;
					
					if($scope.scrolled !== scrolled) {
						$scope.scrolled = scrolled;
						$scope.$applyAsync();
					}
				});
			}
		};
	}
})(window.angular);